import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UTableComponent } from './u-table.component';
import { TableModule } from 'primeng/table';
import { UiInfraModule } from '../../ui-infra.module';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { UTruncateTextModule } from '../u-truncate-text/u-truncate-text.module';
import { UIconModule } from '../u-icon/u-icon.module';
@NgModule({
  declarations: [UTableComponent],
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    UiInfraModule,
    MatTableModule,
    MatSortModule,
    NgScrollbarModule,
    UTruncateTextModule,
    UIconModule,
  ],
  exports: [UTableComponent],
})
export class UTableModule {}
